export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-foreground-300 py-14 md:py-16">
      <div className="section-container">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-lg">
                <i className="ri-chat-smile-2-line"></i>
              </span>
              <span className="text-lg font-heading font-bold text-background-50 whitespace-nowrap">
                吃瓜爆料网
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed mb-5">
              全网吃瓜爆料网站大全，提供2025最新吃瓜爆料网站推荐与排名，覆盖娱乐圈、网红圈、综艺节目等各类吃瓜爆料网站，一站导航，快速直达。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2.5">
              <a href="#index" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">吃瓜导航</a>
              <a href="#cards" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">深度爆料</a>
              <a href="#ranking" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">人气排行</a>
              <a href="#updates" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">最新动态</a>
              <a href="#faq" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">热门话题</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#topics" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">明星恋情爆料</a>
              <a href="#topics" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">综艺节目翻车</a>
              <a href="#topics" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">主播违约纠纷</a>
              <a href="#topics" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">电竞圈转会动态</a>
              <a href="#topics" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">海外吃瓜资讯</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              诚邀各类吃瓜爆料网站、娱乐资讯平台加入合作，共同建设更完善的吃瓜导航生态。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2025 吃瓜爆料网. 本站仅为导航聚合平台，不产生、存储任何爆料内容。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-foreground-300 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="hover:text-foreground-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#contact" className="hover:text-foreground-300 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}